var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#000450",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    d: "M24 16.5H7.333M15.333 7.333l8.667 9-8.667 9"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDA0NTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjE2IiBjeT0iMTYiIHI9IjE1LjUiIHN0cm9rZT0iaW5oZXJpdCIvPgo8bGluZSB4MT0iMjQiIHkxPSIxNi41IiB4Mj0iNy4zMzMzMyIgeTI9IjE2LjUiIHN0cm9rZT0iaW5oZXJpdCIvPgo8cGF0aCBkPSJNMTUuMzMzNCA3LjMzMzVMMjQgMTYuMzMzNUwxNS4zMzM0IDI1LjMzMzUiIHN0cm9rZT0iaW5oZXJpdCIvPgo8L3N2Zz4K";
export { SvgArrow as ReactComponent };